import { z } from "zod";

/** A list search param (trials, sites, genes): a hand-written link may give a single value as plain text. */
export const listParam = () => z.preprocess((v) => (typeof v === "string" ? [v] : v), z.array(z.string()));
